<!-- 
Autocompleter for selecting a provider.
-->
<template>
  <v-autocomplete
    v-model="selected"
    :items="state.data"
    :loading="state.loading"
    :search-input.sync="searchTerm"
    :item-text="getItemText"
    :rules="[rules.required]"
    :readonly="selected ? true : false"
    :autofocus="autofocus"
    hide-no-data
    hide-selected
    clearable
    item-value="id"
    label="Provider*"
    placeholder="Start typing to search providers"
    return-object
  />
</template>

<script>
import * as action from "@/store/providers/action-types";
import _ from "underscore";
import ruleMixins from "@/mixins/rule.mixins";

export default {
  mixins: [ruleMixins],
  props: {
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchTerm: "",
      selected: null
    };
  },
  computed: {
    state() {
      return this.$store.state.providers.autocomplete;
    }
  },
  watch: {
    searchTerm: _.debounce(function searchTerm(query) {
      if (query && (!this.selected || this.getItemText(this.selected) !== query)) {
        this.$store.dispatch(action.AUTOCOMPLETE, query);
      }
    }, 500),
    selected(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    this.$store.dispatch(action.AUTOCOMPLETE, "");
  },
  methods: {
    getItemText(provider) {
      let text = provider.name;
      if (provider.tradingNames && provider.tradingNames != provider.name) {
        text += ` (${provider.tradingNames})`;
      }
      return `${text} [${provider.providerCode}]`;
    }
  }
};
</script>
